import React, { Children } from 'react';

import { SearchState } from './SearchState';

type Props = {
  isFetching: boolean;
  query: string;
  zeroResultsMessage: string;
};

export const Items: React.FC<Props> = ({
  children,
  isFetching,
  query,
  zeroResultsMessage,
}) => {
  return (
    <div className='container'>
      <div className='row'>
        <SearchState
          isZeroResults={!isFetching && Children.count(children) === 0}
          zeroResultsMessage={zeroResultsMessage}
          query={query}
        />
        {children}
      </div>
    </div>
  );
};
